import React from "react";

import Projects from '../components/projects';

const ProjectsPage = () => {

    return (
        <>
            <Projects />
        </>
    );
}
 
export default ProjectsPage;